import { Bairro } from './bairro.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class BairroService {

    constructor(private http: Http){
    }

    getBairros(): Observable<Bairro[]> {
        return this.http.get(`${NTECH_API}/bairro`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/bairro/bairro.service.ts